// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__33ofG","view":"App_view__33pg3"};